export enum IssuerOrganisationsGridColumnId {
  ISSUER_ORGANISATIONS_CHECKBOX = 'ISSUER_ORGANISATIONS_CHECKBOX',
  ISSUER_ORGANISATIONS_ACTIONS = 'ISSUER_ORGANISATIONS_ACTIONS',
  ISSUER_ORGANISATIONS_ISSUER_ORG_ID = 'ISSUER_ORGANISATIONS_ISSUER_ORG_ID',
  ISSUER_ORGANISATIONS_ISSUER_ORGANISATION_NAME = 'ISSUER_ORGANISATIONS_ISSUER_ORGANISATION_NAME',
  ISSUER_ORGANISATIONS_ISSUER_LEI = 'ISSUER_ORGANISATIONS_ISSUER_LEI',
  ISSUER_ORGANISATIONS_ULTIMATE_PARENT_ORG_ID = 'ISSUER_ORGANISATIONS_ULTIMATE_PARENT_ORG_ID',
  ISSUER_ORGANISATIONS_ULTIMATE_PARENT_NAME = 'ISSUER_ORGANISATIONS_ULTIMATE_PARENT_NAME',
  ISSUER_ORGANISATIONS_ULTIMATE_PARENT_LEI = 'ISSUER_ORGANISATIONS_ULTIMATE_PARENT_LEI',
  ISSUER_ORGANISATIONS_ULTIMATE_PARENT_PERM_ID = 'ISSUER_ORGANISATIONS_ULTIMATE_PARENT_PERM_ID',
  ISSUER_ORGANISATIONS_TRADED_ON_US_EXCHANGE = 'ISSUER_ORGANISATIONS_TRADED_ON_US_EXCHANGE',
  ISSUER_ORGANISATIONS_SANCTIONED_SCREENED = 'ISSUER_ORGANISATIONS_SANCTIONED_SCREENED',
  ISSUER_ORGANISATIONS_COMPLIANCE_SUSPENDED = 'ISSUER_ORGANISATIONS_COMPLIANCE_SUSPENDED',
  ISSUER_ORGANISATIONS_LAST_UPDATED_DATE_TIME = 'ISSUER_ORGANISATIONS_LAST_UPDATED_DATE_TIME',
  ISSUER_ORGANISATIONS_LAST_UPDATED_BY = 'ISSUER_ORGANISATIONS_LAST_UPDATED_BY'
}
